// extracted by mini-css-extract-plugin
export var blue = "_3l-f";
export var brand = "_3l-b";
export var darkGrey = "_3l-e";
export var disabled = "_3l-4";
export var disabledSubtle = "_3l-5";
export var error = "_3l-6";
export var green = "_3l-g";
export var grey = "_3l-d";
export var icon = "_3l-0";
export var inherit = "_3l-a";
export var lightGrey = "_3l-c";
export var orange = "_3l-i";
export var pink = "_3l-k";
export var primary = "_3l-1";
export var purple = "_3l-l";
export var red = "_3l-j";
export var secondary = "_3l-2";
export var success = "_3l-9";
export var tertiary = "_3l-3";
export var warning = "_3l-7";
export var warningSecondary = "_3l-8";
export var white = "_3l-m";
export var yellow = "_3l-h";